import { Container, Flex, Title, Table } from '@mantine/core';
import { useSelector } from 'react-redux';
import { ProductDispenser } from '../../../../libraries/dashboardV2';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';
import { ReactComponent as CheckIcon } from '../../../../assets/img/check.svg';
import { ReactComponent as XIcon } from '../../../../assets/img/x.svg';

interface DashboardPeriodDispensersProps {
  dispensers: ProductDispenser[];
}

const DashboardPeriodDispensers = ({ dispensers }: DashboardPeriodDispensersProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  if (!dispensers?.length) return null;

  return (
    <Container className="dashboard-table-container">
      <Flex direction="column" align="flex-start" justify="center">
        <Title order={2} className="dashboard-table-title">
          {lang.DASHBOARD_EQUIPMENT_PRODUCT_DISPENSERS}
        </Title>
      </Flex>

      <Table withRowBorders className="dashboard-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th className="dashboard-table-header">{lang.DASHBOARD_PERIOD_NUMBER}</Table.Th>
            <Table.Th className="dashboard-table-header">{lang.DASHBOARD_PERIOD_DISPENSER_PRODUCT_NAME}</Table.Th>
            <Table.Th className="dashboard-table-header">{lang.DASHBOARD_PERIOD_DISPENSER_STATUS}</Table.Th>
            <Table.Th className="dashboard-table-header">Qtd.</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {dispensers.map(dispenser => (
            <Table.Tr key={dispenser.dispenserid}>
              <Table.Td className="dashboard-dispensers-table-value">{dispenser.dispenserid}</Table.Td>
              <Table.Td className="dashboard-dispensers-table-value">{dispenser.productName || '-'}</Table.Td>
              <Table.Td className="dashboard-dispensers-table-value">
                {dispenser.status === 0 ? <CheckIcon className="status-ok" /> : <XIcon className="status-not-ok" />}
              </Table.Td>
              <Table.Td className="dashboard-dispensers-table-value">{dispenser.quantity ?? '-'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
};

export default DashboardPeriodDispensers;
